
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { StatusItemProps } from ".";
import { loading, endLoading } from "store/status";

interface ApiStatusRemoveInputProps {
    ids: number[]
}

type ApiStatusRemoveOutputProps = OutputBaseProps<{ item: StatusItemProps; }>

export const apiStatusRemove = async (data: ApiStatusRemoveInputProps) => {
    store.dispatch(loading());
    const res = (await axios.delete<ApiStatusRemoveOutputProps>("/api/status/remove", { data }))
        .data;
    store.dispatch(endLoading());
    return res;
};